import {
    UPDATE_SIZE_GUIDE_CONVERSION,
    UPDATE_SIZE_GUIDE_MEASUREMENT_UNIT,
    GET_AVAILABLE_SIZE_GUIDE_MEASUREMENT_UNITS,
    UPDATE_SIZE_GUIDE_FIT,
    SAVE_SIZE_GUIDE
} from '../actions/sizeGuideActions';

export function sizeGuideReducer(productState = {}, action = {}) {
    switch (action.type) {

        case GET_AVAILABLE_SIZE_GUIDE_MEASUREMENT_UNITS:
            return Object.assign({}, productState, {
                sizeGuide: Object.assign({}, productState.sizeGuide, {
                    selectedFit: Object.assign({}, productState.sizeGuide.selectedFit, {
                        hasInches: action.payload.hasInches,
                        hasCentimeters: action.payload.hasCentimeters
                    })
                })
            });

        case UPDATE_SIZE_GUIDE_CONVERSION:
            return Object.assign({}, productState, {
                sizeGuide: Object.assign({}, productState.sizeGuide, {
                    selectedConversion: action.payload.selectedConversion
                })
            });

        case UPDATE_SIZE_GUIDE_MEASUREMENT_UNIT:
            return Object.assign({}, productState, {
                sizeGuide: Object.assign({}, productState.sizeGuide, {
                    selectedUnit: action.payload
                })
            });

        case UPDATE_SIZE_GUIDE_FIT:
            return Object.assign({}, productState, {
                sizeGuide: Object.assign({}, productState.sizeGuide, {
                    selectedFit: action.payload.selectedFit
                })
            });

        case SAVE_SIZE_GUIDE:
            return Object.assign({}, productState, {
                sizeGuide: action.payload.sizeGuide
            });

        default:
            return productState;
    }
}
